var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProfileFavorites(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_heart_hider") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_heart_hider",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3.000000, 3.000000)",
    fill: "#333939"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2573,3.26 C3.2973,3.2 3.3573,3.15 3.4073,3.1 C3.9673,2.59 4.6873,2.3 5.4473,2.3 C6.2973,2.3 7.0773,2.64 7.6673,3.27 L8.7573,4.43 C8.9273,4.61 9.1773,4.72 9.4373,4.72 C9.6973,4.72 9.9473,4.61 10.1273,4.43 L11.2273,3.26 C11.7983,2.65 12.5973,2.3 13.4273,2.3 C14.2573,2.3 15.0573,2.65 15.6173,3.26 C16.8973,4.63 16.9073,6.78 15.6373,8.15 L9.4373,14.69 L3.2573,8.17 C1.9773,6.79 1.9773,4.63 3.2573,3.26 M17.3073,1.69 C16.3073,0.62 14.8973,0 13.4273,0 C11.9573,0 10.5373,0.62 9.5473,1.69 L9.4373,1.8 L9.3373,1.69 C8.3373,0.62 6.9173,0 5.4473,0 C4.1073,0 2.8273,0.5 1.8373,1.42 C1.7473,1.51 1.6573,1.6 1.5673,1.69 C-0.5227,3.95 -0.5227,7.48 1.5673,9.73 L8.7473,17.3 C8.9273,17.49 9.1773,17.6 9.4373,17.6 C9.6873,17.6 9.9173,17.51 10.1273,17.3 L17.3073,9.73 C19.3973,7.48 19.3973,3.95 17.3073,1.69",
    id: "Fill-1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileFavorites);
export default __webpack_public_path__ + "static/media/ic_profile_favorites.44332128.svg";
export { ForwardRef as ReactComponent };